import request from '@/CommonDP/utils/request';
// 标准策划相关接口
export default {
  // 判断是否设置过 设置的是哪一个
  getPrjRevitVersion(prjId) {
    return request
      .get(`/standard-plan/getPrjRevitVersion?prjId=${prjId}`)
      .then((res) => res);
  },
  // 列表数据 接口
  getSysRevitVersionList() {
    return request
      .get(`/standard-plan/getSysRevitVersionList`)
      .then((res) => res);
  },
  // 设置接口
  setPrjRevitVersion(prjId, revitId) {
    return request
      .get(
        `/standard-plan/setPrjRevitVersion?prjId=${prjId}&revitId=${revitId}`
      )
      .then((res) => res);
  },
  getStandardFrameFiles(fileName, prjId, enterpriseId) {
    return request
      .get(
        `/standardFrameMaintenance/getStandardFrameFiles?fileName=${fileName}&prjId=${prjId}&enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  batchAdd(data) {
    return request
      .post(`/project/standardFrameSetting/batchAdd`, data)
      .then((res) => res);
  },
  getStandardFiles(prjId, enterpriseId) {
    return request
      .get(
        `/project/standardFrameSetting/getStandardFiles?prjId=${prjId}&enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  batchDelete(data) {
    return request
      .post(`/project/standardFrameSetting/batchDelete`, data)
      .then((res) => res);
  },
  getSpecList(prjId) {
    return request
      .get(`/project/getSpecList?prjId=${prjId}`)
      .then((res) => res);
  },
  getRevitTemplateList(data) {
    return request
      .post(`/project/revitTemplateSetting/getRevitTemplateList`, data)
      .then((res) => res);
  },
  getBySpecId(fileName, specId, prjId, enterpriseId) {
    return request
      .get(
        `/revitSystemModelMaintenance/getBySpecId?fileName=${fileName}&specId=${specId}&prjId=${prjId}&enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  delete(data) {
    return request
      .post(`/project/revitTemplateSetting/delete`, data)
      .then((res) => res);
  },
  revitTemplateSettingadd(data) {
    return request
      .post(`/project/revitTemplateSetting/add`, data)
      .then((res) => res);
  }
};
